export const zIndex = {
  footer: 0,
  suitsOnCorners: 1,
  underlyingBg: 0,
  header: 13002,
}
